import { render, staticRenderFns } from "./ODValidationView.vue?vue&type=template&id=b0bcd678"
import script from "./ODValidationView.vue?vue&type=script&lang=js"
export * from "./ODValidationView.vue?vue&type=script&lang=js"
import style0 from "./ODValidationView.vue?vue&type=style&index=0&id=b0bcd678&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports